import type WixData from '@wix/wix-data-core/dist/types/data-api'
import type { WixDataItem } from '@wix/wix-data-client-common-standalone'
import type { PageLinkFieldDefinition } from './page-link-field/editorActions'

export async function findFirstItemMatchingDynamicPage({
  collectionId,
  prefix,
  innerRoute,
  wixData,
  pageLinkField,
}: {
  collectionId: string
  prefix: string
  innerRoute: string
  wixData: WixData
  pageLinkField: PageLinkFieldDefinition | null
}): Promise<WixDataItem | null> {
  if (!pageLinkField) {
    return null
  }

  const pageLinkQuery = wixData
    .query(collectionId)
    .eq(pageLinkField.key, `/${prefix}/${innerRoute}`)

  try {
    const {
      items: [item],
    } = await pageLinkQuery.limit(1).find()
    return item
  } catch {
    return null
  }
}
